import { icBackArrow } from "../image/image-src";
import { IcBtnSm } from "./IcBtn";

export const BackBtn = (props?: { ic?: string; className?: string }) => {
  const goBack = () => {
    window.history.back();
  };
  return (
    <IcBtnSm
      ic={props?.ic ?? icBackArrow}
      className={props?.className}
      onClick={goBack}
    />
  );
};
